import { checkResponse, hashCode, myReplacer, parseJSONDate } from "src/components/js/statics1";
import toimitusBetoniClass from "./toimitusBetoniClass";
import betoniClass from "../betoni/betoniClass";
import { toimitus_kuorma_delete } from "./toimitusFunctions";

export default class toimitusClass {
  constructor(keikkaId) {
    this.keikkaId = keikkaId;
    this.token = undefined;
    this.socket = undefined;
    this.isLoaded = false;
    this.isSaved = false;

    this.aikaComment = "";
    this.toimitusId = 0;
    this.ignore = false;
    this.pumppuAika = 0;
    this.pumppuComment = "";
    this.pumppuLinja = 0;
    this.pumppuKesto = 0;
    this.pumppuPuomi = 0;
    this.toimitusComment = "";
    this.verifyComment = "";
    this.verifyPersonId = null;
    this.verifyTime = 0;
    this.lastModifiedTime;
    this.vehicleId = 0;
    this.kuskiPersonId = 0;
    this.betoni = [];
    this.betoniKuormat = [];

    this.tyhjänäTyömaalle = false;
    this.pesuTyömaalla = false;
    this.ylijäämäId = 0;
    this.ylijäämäKg = 0;
    this.ylijäämäKm = 0;

    this.tilausToimitettu = false;

    this.toimitusTilaId = 0;
    this.toimitusTilaName = "";

    this.m3 = 0;

    this.accepted = {
      klo: false,
      betonit: false,
      ylijäämä: false,
      irtolinja: false,
      muut: false,
    };
  }

  get isLocked() {
    // kun verifyPersonId on laitettu, niin toimitus on lukittu
    if (this.verifyPersonId == null) return false;
    return true;
  }

  async reloadToimitusData() {
    await this.init(this.token, this.socket);
  }

  async initFromKeikka(keikkaData = null, gridKeikka = null, token) {
    if (keikkaData == null && gridKeikka == null) return false;
    // update toimitusTilaId and toimitusTilaName to next
    this.toimitusTilaId = 20;
    this.toimitusTilaName = "Aloitettu";
    this.ignore = false;
    this.pumppuAika = keikkaData?.pumppu.pumppuAika || gridKeikka?.timeStart || null;
    this.pumppuLinja = keikkaData?.pumppu.pumppuLinja || gridKeikka?.pumppuLinja || 0;
    this.pumppuPuomi = keikkaData?.pumppu.pumppuPuomi || gridKeikka?.pumppuPuomi || 0;
    this.vehicleId = keikkaData?.pumppu.vehicle.vehicleId || gridKeikka?.vehicleId || 0;
    this.kuskiPersonId =
      keikkaData?.pumppu.pumppariList[0]?.personId || gridKeikka.kuskit[0]?.personId;
    this.tyhjänäTyömaalle = keikkaData?.pumppu.isPumppu || gridKeikka?.tyhjänäTyömaalle || false;
    for (let i = 0; i < this.betoni.length; i++) {
      const betoni = this.betoni[i];
      const keikkaBetoniId = betoni.keikkaBetoniId;
      const betonit = keikkaData?.betoni || gridKeikka.betonit;
      const keikkaBetoni = betonit.find((b) => b.keikkaBetoniId == keikkaBetoniId);
      if (keikkaBetoni == null) {
        console.log("keikkabetoni ei löydy!!!");
        continue; // ei löydy, skip}
      }
      betoni.m3 = keikkaBetoni.m3;
    }
    // delete all betonikuormat
    for (let i = 0; i < this.betoniKuormat.length; i++) {
      const toimitusBetoniId = this.betoniKuormat[i].toimitusBetoniId;
      await toimitus_kuorma_delete(this, toimitusBetoniId, token);
    }
    this.betoniKuormat = [];
    return true;
  }

  async init(token, socket) {
    try {
      this.token = token;
      this.socket = socket;
      const _result = await fetchToimitusData(this.keikkaId, token);

      const __toimitus = _result.toimitus;
      const __toimitusBetonit = _result.toimitusBetoni;
      const __keikkaBetonit = _result.keikkaBetoni;

      if (__toimitus == null) {
        console.log("toimitusClass.init: fetchToimitusData returned null");
        this.isLoaded = true;
        return true;
      }
      const _data = __toimitus[0];
      this.aikaComment = _data.aikaComment;
      this.toimitusId = _data.toimitusId;
      this.ignore = _data.ignore;
      this.pumppuAika = _data.pumppuAika ? parseJSONDate(_data.pumppuAika) : null;
      this.pumppuComment = _data.pumppuComment;
      this.pumppuLinja = Number(_data.pumppuLinja);
      this.pumppuKesto = _data.pumppuKesto;
      this.pumppuPuomi = _data.pumppuPuomi;
      this.toimitusComment = _data.toimitusComment;
      this.verifyComment = _data.verifyComment;
      this.verifyPersonId = _data.verifyPersonId;
      this.verifyTime = _data.verifyTime ? parseJSONDate(_data.verifyTime) : null;
      this.vehicleId = _data.vehicleId;
      this.kuskiPersonId = _data.kuskiPersonId;
      this.tyhjänäTyömaalle = _data.tyhjänäTyömaalle || false;
      this.pesuTyömaalla = _data.pesuTyömaalla;
      this.ylijäämäId = _data.ylijäämäId;
      this.ylijäämäKg = _data.ylijäämäKg;
      this.ylijäämäKm = _data.ylijäämäKm;
      this.tilausToimitettu = _data.tilausToimitettu;
      this.toimitusTilaId = _data.toimitusTilaId;
      this.toimitusTilaName = _data.toimitusTilaName;
      this.accepted.klo = _data.toimitusAccepted;
      this.accepted.betonit = _data.betonitAccepted;
      this.accepted.ylijäämä = _data.ylijaamaAccepted;
      this.accepted.irtolinja = _data.irtolinjaAccepted;
      this.accepted.muut = _data.muutAccepted;

      // for each toimitusBetoni
      if (__toimitusBetonit != null)
        for (let i = 0; i < __toimitusBetonit.length; i++) {
          const a = new toimitusBetoniClass();
          a.m3 = __toimitusBetonit[i].m3;
          a.toimitusBetoniId = __toimitusBetonit[i].toimitusBetoniId;
          a.toimitusId = __toimitusBetonit[i].toimitusId;
          a.keikkaBetoniId = __toimitusBetonit[i].keikkaBetoniId;
          a.nouto = __toimitusBetonit[i].nouto;
          a.minutes = __toimitusBetonit[i].minutes;
          a.startTime = new Date(parseJSONDate(__toimitusBetonit[i].startTime));
          a.endTime = new Date(parseJSONDate(__toimitusBetonit[i].endTime));
          a.vehicleRegNo = __toimitusBetonit[i].vehicleRegNo;
          a.vehicleNo = __toimitusBetonit[i].vehicleNo;
          a.kkNumber = __toimitusBetonit[i].kkNumber;
          a.comments = __toimitusBetonit[i].comments;
          this.betoniKuormat.push(a);
        }

      // for each keikkaBetoni
      if (__keikkaBetonit != null)
        for (let i = 0; i < __keikkaBetonit.length; i++) {
          const a = new betoniClass();
          await a.loadApiData(__keikkaBetonit[i].keikkaBetoniId, this.token);
          a.m3 = a.toimitus?.m3 || a.m3;
          this.betoni.push(a);
        }

      this.isLoaded = true;
      return true;
    } catch (error) {
      console.log(error);
      return false;
    }
  }

  async toimitusKeikkaBetoni_saveM3(selectedKeikkaBetoniId = null) {
    if (!this.isLoaded) return false;
    console.log("toimitusKeikkaBetoni_saveM3");
    let success = true;
    for (let i = 0; i < this.betoni.length; i++) {
      if (
        selectedKeikkaBetoniId != null &&
        this.betoni[i].keikkaBetoniId != selectedKeikkaBetoniId
      ) {
        continue; // skip this betoni
      }
      const _betoni = this.betoni[i];
      const body = {
        keikkaBetoniId: _betoni.keikkaBetoniId,
        m3: _betoni.m3,
      };
      const addr = "/api/toimitus/keikkaBetoni/saveM3";
      const response = await fetch(import.meta.env.VITE_SERVER_URL + addr, {
        method: "POST",
        headers: {
          "x-access-token": `${this.token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      });
      if (!response.ok) {
        console.log("saveToimitusBetoniDataToDB failed");
        success = false;
      }
    }
    return success;
  }

  async saveToimitusDataToDB() {
    console.log("saveToimitusDataToDB");
    if (!this.isLoaded) return;
    const body = {
      toimitusId: this.toimitusId,
      keikkaId: this.keikkaId,
      aikaComment: this.aikaComment,
      pumppuAika: this.pumppuAika,
      pumppuComment: this.pumppuComment,
      pumppuLinja: Number(this.pumppuLinja),
      pumppuKesto: Number(this.pumppuKesto),
      pumppuPuomi: this.pumppuPuomi,
      toimitusComment: this.toimitusComment,
      vehicleId: this.vehicleId,
      kuskiPersonId: this.kuskiPersonId,
      tyhjänäTyömaalle: this.tyhjänäTyömaalle,
      pesuTyömaalla: this.pesuTyömaalla,
      ylijäämäId: this.ylijäämäId,
      ylijäämäKg: this.ylijäämäKg,
      ylijäämäKm: this.ylijäämäKm,
      toimitusTilaId: this.toimitusTilaId,
    };
    const addr = "/api/toimitus/saveData";
    const response = await fetch(import.meta.env.VITE_SERVER_URL + addr, {
      method: "POST",
      headers: {
        "x-access-token": `${this.token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });
    // save betoni data
    const response2 = await this.toimitusKeikkaBetoni_saveM3();
    return response.ok && response2;
  }

  async saveIgnoreToDB() {
    if (!this.isLoaded) return;
    console.log("saveIgnoreToDB");
    const addr = "/api/toimitus/saveIgnore";
    const response = await fetch(import.meta.env.VITE_SERVER_URL + addr, {
      method: "POST",
      headers: {
        "x-access-token": `${this.token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        keikkaId: this.keikkaId,
        ignore: this.ignore,
      }),
    });
    return response.ok;
  }

  getBetoni(keikkaBetoniId) {
    if (!this.isLoaded) return null;
    for (let i = 0; i < this.betoni.length; i++) {
      if (this.betoni[i].keikkaBetoniId == keikkaBetoniId) return this.betoni[i];
    }
    return null;
  }

  get totM3() {
    let _m3 = 0;
    this.betoni.forEach((betoni) => (_m3 += Number(betoni.m3)));
    return _m3;
  }

  toimitusKestoTarkkuus(keikkaData) {
    if (!this.isLoaded) return null;
    if (this.pumppuKesto == 0) return null;
    if (this.pumppuKesto == undefined) return null;
    const toimKesto = this.pumppuKesto;
    const keikKesto = keikkaData.pumppu.pumppuKesto;
    let tarkkuus = 0;
    if (toimKesto < keikKesto) tarkkuus = toimKesto / keikKesto;
    else tarkkuus = keikKesto / toimKesto;
    return Math.round(tarkkuus * 100) + "%";
  }

  get ylijäämäSelite() {
    if (!this.isLoaded) return "Ladataan...";
    const a = toimitus_ylijäämäIdSelite(this.ylijäämäId);
    return a;
  }

  get hash() {
    if (!this.isLoaded) return -1;
    let a =
      hashCode(this.aikaComment) +
      (+this.toimitusId || 0) +
      (this.ignore ? 1 : 2) +
      Math.round((this.pumppuAika || 0) / 91468) +
      hashCode(this.pumppuComment) +
      (+this.pumppuLinja || 0) +
      (+this.pumppuKesto || 0) +
      (+this.pumppuPuomi || 0) +
      hashCode(this.toimitusComment) +
      hashCode(this.verifyComment) +
      (+this.verifyPersonId || 0) +
      Math.round(this.verifyTime || 0) / 65890 +
      (+this.vehicleId || 0) +
      (+this.kuskiPersonId || 0) +
      (this.tyhjänäTyömaalle == null ? 0 : this.tyhjänäTyömaalle ? 2 : 4) +
      (this.pesuTyömaalla == null ? 0 : this.pesuTyömaalla ? 8 : 16) +
      Number(+this.ylijäämäId || -1) +
      Number(+this.ylijäämäKg || -1) +
      Number(+this.ylijäämäKm || -1) +
      Number(+this.m3 || -1) +
      (this.isSaved ? 32 : 64) +
      (+this.toimitusTilaId || 0);

    // loop betoni
    // for (let i = 0; i < this.betoni.length; i++) {
    //   a += this.betoni[i].hash || this.betoni.betoniHash;
    //   console.log(this.betoni.betoniHash && this.betoni.betoniHash());
    // }

    for (let i = 0; i < this.betoniKuormat.length; i++) {
      a += this.betoniKuormat[i].toimitusBetoniId || 0;
      a += this.betoniKuormat[i].m3 || 0;
      a += this.betoniKuormat[i].minutes || 0;
    }

    if (isNaN(a)) {
      console.log("Virhe hashissa: " + a);
    }
    return a;
  }
  // create json string without circular references
  json() {
    return JSON.stringify(this, myReplacer, 2);
  }
}

async function fetchToimitusData(keikkaId, token) {
  if (keikkaId == null) return null;
  if (keikkaId == 0) return null;
  const addr = "/api/toimitus/get/" + keikkaId;
  const response = await fetch(import.meta.env.VITE_SERVER_URL + addr, {
    method: "GET",
    headers: {
      "x-access-token": `${token}`,
      "Content-Type": "application/json",
    },
  });
  const cResponse = await checkResponse(response, "toimitusClass.js:fetchToimitusData");
  const data = cResponse.data;
  if (data == null || data.length == 0) {
    console.log("Liian vanha tilaus, ei toimitusdata mahdollisuutta, tai virhe.");
    return null;
  } else {
    return data;
  }
}

// async function fetchToimitusBetoniData(toimitusId, token) {
//   if (toimitusId == null) return null;
//   if (toimitusId == 0) return null;
//   const addr = "/api/toimitus/getBetonit/" + toimitusId;
//   const response = await fetch(import.meta.env.VITE_SERVER_URL + addr, {
//     method: "GET",
//     headers: {
//       "x-access-token": `${token}`,
//       "Content-Type": "application/json",
//     },
//   });
//   const cResponse = await checkResponse(response, "toimitusClass.js:fetchToimitusBetoniData");
//   const data = cResponse.data;
//   if (data == null || data.length == 0) {
//     console.log("Liian vanha tilaus, ei toimitusbetonidata mahdollisuutta, tai virhe.");
//     return null;
//   } else {
//     return data;
//   }
// }

export function toimitus_ylijäämäIdSelite(ylijäämäId) {
  switch (ylijäämäId) {
    case null:
      return "Ei valintaa";
    case 0:
      return "Kaikki meni";
    case 1:
      return "Perät jäi";
    case 2:
      return "Loput pois";
    default:
      return "???";
  }
}

export async function toimitus_verify(keikkaId, verifyComment, verifiedByPersonId, token) {
  if (!this.isLoaded) return;
  const addr = "/api/toimitus/saveVerify";
  const response = await fetch(import.meta.env.VITE_SERVER_URL + addr, {
    method: "POST",
    headers: {
      "x-access-token": `${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      keikkaId: keikkaId,
      verifyComment: verifyComment,
      verifyPersonId: verifiedByPersonId,
      verifyTime: new Date(),
    }),
  });
  return (await checkResponse(response, "toimitusClass.js:saveToimitusVerifyToDB")).success;
}
